import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { PersonExperienceParams } from './PersonExperience.type';

let listTypesRequest: any = null;

const personExperienceService = {
  getList: ({ ids }: PersonExperienceParams) => {
    listTypesRequest && listTypesRequest.cancel();
    listTypesRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`people/experience`), {
      cancelToken: listTypesRequest.token,
      params: {
        filter: {
          ids,
        },
      },
    });
  },
};

export default personExperienceService;
